import React from "react";
import { elementType } from "prop-types";
import ApplicationError from "@insightfulscience/smart-react/ApplicationError";
import errorPropType from "./error-prop-type";
import Error400 from "./Error400";
import Error401 from "./Error401";
import Error403 from "./Error403";
import Error404 from "./Error404";
import Error500 from "./Error500";
import ErrorDetails from "./ErrorDetails";
import ErrorLayout from "./ErrorLayout";
import { notifySentry } from "../sentry";

const errorComponents = {
	400: Error400,
	401: Error401,
	403: Error403,
	404: Error404,
};

const AppError = ({ error, Layout = ErrorLayout, ...props }) => {
	const { code } = error;
	const ErrorComponent = errorComponents[code] || Error500;

	return (
		<Layout extra={<ErrorDetails error={error} />} {...props}>
			<ErrorComponent error={error} />
		</Layout>
	);
};

AppError.getInitialProps = context => {
	const { err, res } = context;

	const error = ApplicationError.of(err ?? {});

	if (res) {
		res.statusCode = error.code;
	}

	notifySentry(err, context);

	if (error.code >= 500 && error.originalError != null) throw error.originalError;

	return { error: error.toSerializable() };
};

AppError.propTypes = {
	error: errorPropType,
	Layout: elementType,
};

export default AppError;
